module.exports = __webpack_public_path__ + "img/40_38_065_720.5083d821.jpg";